import React from 'react';
import Modal from '../Modal/Modal';
import Table from '../DesignLibrary/Table/Table';
import THead from '../DesignLibrary/Table/THead';
import TBody from '../DesignLibrary/Table/TBody';
import TableRow from '../DesignLibrary/Table/TableRow';
import TH from '../DesignLibrary/Table/TH';
import TD from '../DesignLibrary/Table/TD';
import s from './ExemptionLimitsModal.module.scss';

interface ExemptionLimitRow {
  statute: string;
  description: string;
  totalLimit: string;
  used: string;
  available: string;
  status: string;
  statusColor: 'green' | 'red';
}

interface ExemptionLimitsModalProps {
  open: boolean;
  onClose: () => void;
  data?: ExemptionLimitRow[];
}

const ExemptionLimitsModal: React.FC<ExemptionLimitsModalProps> = ({ open, onClose, data }) => {
  if (!open) return null;
  return (
    <Modal onClose={onClose} isWide={true} title="Exemption Limits & Current Usage">
      <Table>
        <THead>
          <TableRow>
            <TH label="Exemption Statute" />
            <TH label="Description" />
            <TH label="Total Limit" />
            <TH label="Used" />
            <TH label="Available" />
            <TH label="Status" />
          </TableRow>
        </THead>
        <TBody>
          {data?.map((row, idx) => (
            <TableRow key={idx}>
              <TD>{row.statute.split('\n').map((line, i) => <p className='caption' key={i}>{line}</p>)}</TD>
              <TD label={row.description} compact />
              <TD label={row.totalLimit} compact />
              <TD label={row.used} compact />
              <TD label={row.available} compact />
              <TD>
                <span className={`caption ${s.status} ${s[row.statusColor]}`}>
                  {row.status}
                </span>
              </TD>
            </TableRow>
          ))}
        </TBody>
      </Table>
    </Modal>
  );
};

export default ExemptionLimitsModal;
